import { FC, useCallback, useEffect, useState, ChangeEvent } from 'react';
import { Link } from 'react-router-dom';
import classes from '../../asset/css/subscription-cancel/cancel.module.css';
import { CancelSurveyEnable, SurveyAnswer } from '../../types/api/subscriptions-api-type';

export const Cancel: FC<{ 
  subscriptionCancelFunc: (surveyAnswer: SurveyAnswer) => void,
  survey: CancelSurveyEnable
}> = ({ subscriptionCancelFunc, survey }) => {

  const [surveyAnswer, setSurveyAnswer] = useState<SurveyAnswer>({
    selected: [],
    extraField: '' 
  });

  const [acceptConditions, setAcceptConditions] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);

  const btnClickHandler = useCallback(() => {
    setIsProcessing(true);
    subscriptionCancelFunc(surveyAnswer);
  }, [subscriptionCancelFunc, surveyAnswer]);

  const handleAcceptConditions = useCallback( () => {
    setAcceptConditions(!acceptConditions)
  }, [acceptConditions])

  const handleChangeReason = useCallback((ev: ChangeEvent<HTMLInputElement>) => {
    if (surveyAnswer.selected.includes(ev.target.value)) {
      setSurveyAnswer({ ...surveyAnswer, selected: surveyAnswer.selected.filter(value => value !== ev.target.value) });
    } else {
      setSurveyAnswer({ ...surveyAnswer, selected: [...surveyAnswer.selected, ev.target.value] });
    }
  }, [surveyAnswer]);

  const handleChangeExtra = useCallback((ev: ChangeEvent<HTMLTextAreaElement>) => {
    setSurveyAnswer({ ...surveyAnswer, extraField: ev.target.value });
  }, [surveyAnswer]);

  return (
    <>
      <div className={classes.mypage_subsc_cancel_confirm}>
        <div className={classes.mypage_subsc_cancel_confirm_text}>
          <p>BOXプランの解約</p>
          <h2 className={classes.mypage_subsc_cancel_title}>お届けの<span style={{ fontSize: '127%' }}>一時停止</span>も可能です。</h2>
          <h2 className={classes.mypage_subsc_cancel_subtitle}>本当に「解約」してもよろしいですか？</h2>
          <div className={classes.mypage_subsc_cancel_box}>
            <h3 className={classes.mypage_subsc_cancel_box_title}>＼BOXプランは停止期間の制限ナシ／</h3>
            <p>
              マイページからいつでも再開いただけます。<br />
              <br />
              BOXプランの会員さま限定で、お得な情報や、<br />
              キャンペーン情報もお届けします。<br />
              停止方法は「<a style={{ textDecoration: 'underline' }} href={`${document.referrer.replace(/\/$/, '')}/pages/faq_box#60`} target="_parent">コチラ</a>」<br />
            </p> 
          </div>
          <p>解約をご希望の方は、アンケートにご回答のうえ、<br />
          「解約する」ボタンを押してください。</p>
          <p className={classes.mypage_subsc_cancel_warning}>①解約前に既に確定したご注文はキャンセルできません。<br/>
          ②解約前に既に確定済みの注文の有無を「注文履歴」で確認しました。<br/>
          ③既に確定済みの注文は解約後であっても受け取ります。</p>
          <label style={{textAlign: 'center'}}><input type="checkbox" name="acceptConditions" onChange={handleAcceptConditions}/><span>上記①～③の内容を確認し、承諾しました。</span></label>
        </div>
        {/* キャンセル時アンケート */}
        {survey.cancelSurveyEnable ? (
          <>
            <div className={`${classes.mypage_subsc_cancel_survey} ${acceptConditions ? '' : classes.mypage_subsc_cancel_survey_disabled}`}>
              <h3>{survey.cancelSurveyLeadText}</h3>
              <div className={classes.mypage_subsc_cancel_survey_reasons}>
                <h4>今回ご解約される理由を以下から選択してください</h4>
                {survey.reasons.map((reason, index) => (
                  <label key={index}>
                    <input 
                      type="checkbox"
                      name="selected"
                      value={reason.text}
                      checked={surveyAnswer.selected.includes(reason.text)}
                      onChange={handleChangeReason}
                      disabled={!acceptConditions}
                    />
                    <span>{reason.text}</span>
                  </label>
                ))}
              </div>
              {survey.cancelSurveyExtraField && (
                <div className={classes.mypage_subsc_cancel_survey_extra}>
                  <h4>その他、お気づきになった点があればご記入ください</h4>
                  <textarea value={surveyAnswer.extraField} onChange={handleChangeExtra} placeholder="内容を入力" disabled={!acceptConditions} ></textarea>
                </div>
              )}
            </div>
          </>
        ) : (
          <></>
        )}

        <div className={classes.mypage_subsc_cancel_buttons}>
          <button 
            onClick={btnClickHandler}
            disabled={(survey.cancelSurveyEnable && survey.cancelSurveyRequire && surveyAnswer.selected.length === 0 ) || !acceptConditions || isProcessing}
            >{ isProcessing ? '処理中です...' : '解約する' }</button>
          <Link to="/">もどる</Link>
        </div>
      </div>
    </>
  );
};
